import { createAction } from 'redux-actions'

const ns = 'importDataAdmin/'

export const importData = createAction(`${ns}IMPORT_DATA`)
export const importDataSuccess = createAction(`${ns}IMPORT_DATA_SUCCESS`)
export const importDataFail = createAction(`${ns}IMPORT_DATA_FAIL`)
export const clearImportDataResult = createAction(`${ns}CLEAR_RESULT`)
